import { logger } from '@/services/logger.service';

export const getExtensionFromUri = (uri: string): string => {
  if (!uri) {
    logger.error('There is not URI to get extension name');
  }

  return uri.replace(/sip:|@.+/g, '');
};

export const getDomainFromUri = (uri: string): string => {
  if (!uri) {
    logger.error('There is not URI to get extension name');
  }

  return uri.replace(/sip:.+@/g, '');
};
